import { Component } from '@angular/core';

import type { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/core';

@Component({
	selector: 'formly-field-checkbox',
	template: `
		<vp-checkbox
			[customFormControl]="formControl"
			[disabled]="props.disabled"
			[hasError]="showError"
			[initialValue]="formControl.value"
			[inputId]="field.id"
			[isOptional]="props['optional']"
			[isValid]="formControl.valid"
			[name]="field.key.toString()"
			[readonly]="props.readonly"
			[showAsToggle]="props['showAsToggle']"
			ngDefaultControl
		>
			{{ props['checkboxLabel'] | translate }}
		</vp-checkbox>
	`,
	standalone: false,
})
export class CheckboxComponent extends FieldType<FieldTypeConfig> {}
